import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://turismosanroman.com/turismobackend/public/api/',
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,

  (error) => {
    if (error.response?.status === 401) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('name');
      sessionStorage.removeItem('role');
      sessionStorage.removeItem('email');

      sessionStorage.setItem('sessionExpired', 'true');

      window.location.replace('/login');
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;